import BaseModelAPI from '../BaseModelAPI';

export default class ApprovalGroup extends BaseModelAPI {
	static entity = 'approvalgroup';
	static entityName = 'approvalgroup';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.description = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}